<template>
  <file-picker :title="title" @input="change" accept=".xlsx, .xls, .csv" v-model="files"></file-picker>
</template>
<script>
import XLSX from 'xlsx'
export default {
  props: ['title'],
  data() {
    return {
      show: false,
      uploading: false,
      files: []
    }
  },
  methods: {
    findFirstSheet(book) {
      for (let key in book.Sheets) {
        return book.Sheets[key]
      }
    },
    change() {
      var fileType = this.files[0].name.split('.')[
        this.files[0].name.split('.').length - 1
      ]

      if (fileType !== 'csv' && fileType !== 'xlsx' && fileType !== 'xls') {
        this.$message('', 'アップロードファイルの形式が正しくありません')
        return
      }

      Promise.all(
        this.files.map(f => {
          return new Promise(resolve => {
            var reader = new FileReader()
            reader.onload = e => {
              let book = XLSX.read(new Uint8Array(e.target.result), {
                type: 'array'
              })

              //只需获取第一张sheet
              let rows = XLSX.utils.sheet_to_json(this.findFirstSheet(book), {
                header: 1,
                raw: true
              })
              resolve(rows)
            }
            reader.readAsArrayBuffer(f.file)
          })
        })
      ).then(tables => {
        if (tables.length !== 1) return
        this.$emit('input', tables[0])
      })
    }
  }
}
</script>
